import { useState } from "react";

export default function GalleryLightbox({ images = [], title = "Billedgalleri" }) {
  const [activeImageIndex, setActiveImageIndex] = useState(null);

  if (!images || images.length === 0) {
    return null;
  }

  const openLightbox = (index) => setActiveImageIndex(index);
  const closeLightbox = () => setActiveImageIndex(null);

  const prevImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="space-y-6">
      {/* Grid view of images */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {images.map((imgUrl, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => openLightbox(idx)}
            className="group relative aspect-4/3 overflow-hidden rounded-lg bg-gray-900 focus:outline-none focus:ring-2 focus:ring-[#d96b27] shadow-sm hover:shadow-md transition-all cursor-pointer"
          >
            <img
              src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/${imgUrl.replace('https://assets.auxodev.dk/', '')}`}
              alt={`${title} - Billede ${idx + 1}`}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <span className="bg-[#d96b27] text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded shadow">
                <i className="fa-solid fa-magnifying-glass-plus mr-1.5" aria-hidden="true" />
                Forstør
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {activeImageIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={closeLightbox}
        >
          {/* Close button */}
          <button
            type="button"
            onClick={closeLightbox}
            className="absolute top-4 right-4 z-50 text-white hover:text-[#d96b27] bg-gray-900/80 p-3 rounded-full transition-colors focus:outline-none"
            aria-label="Luk galleri"
          >
            <i className="fa-solid fa-xmark text-2xl" aria-hidden="true" />
          </button>

          {/* Prev button */}
          <button
            type="button"
            onClick={prevImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-50 text-white hover:text-[#d96b27] bg-gray-900/80 p-3.5 rounded-full transition-colors focus:outline-none"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true" />
          </button>

          {/* Image Container */}
          <div
            className="max-w-5xl max-h-[85vh] relative flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[activeImageIndex]}
              alt={`${title} ${activeImageIndex + 1}`}
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />
            <div className="mt-4 text-center text-gray-300 text-sm font-medium">
              {title} — Billede {activeImageIndex + 1} af {images.length}
            </div>
          </div>

          {/* Next button */}
          <button
            type="button"
            onClick={nextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-50 text-white hover:text-[#d96b27] bg-gray-900/80 p-3.5 rounded-full transition-colors focus:outline-none"
            aria-label="Næste billede"
          >
            <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true" />
          </button>
        </div>
      )}
    </div>
  );
}
